<div (click)="isPopinDeployed = false"
  [ngClass]="{blackshield:isPopinDeployed }">
</div>
<div [ngClass]="{extend:isPopinDeployed, retract:!isPopinDeployed }" class="right-popin-container-{{theme}}" (click)="isPopinDeployed = false">
  <ng-content></ng-content>
</div>
